import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialog } from '../../../common/interfaces/confirm-dialog.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-confirm',
    standalone: false,
    templateUrl: './confirm.component.html',
    styleUrl: './confirm.component.scss'
})
export class ConfirmComponent implements OnInit {
    protected data = inject<ConfirmDialog>(MAT_DIALOG_DATA);

    private dialogRef = inject(MatDialogRef<ConfirmComponent>);
    private destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        this.close();
                    }
                },
            });
    }

    protected close(): void {
        this.dialogRef.close(false);
    }

    protected confirm(): void {
        this.dialogRef.close(true);
    }
}

